var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var allowedPublicStatuses = [
    "active",
    "closed",
    "finished",
    "published",
];
export var sortConsultationItems = function (items) {
    return (items || []).slice().sort(function (left, right) { return left.order - right.order; });
};
export var findContributionBySource = function (contributions, consultationId, source) {
    return contributions.find(function (entry) {
        return entry.contribution.consultationId === consultationId &&
            entry.contribution.source === source;
    });
};
export var buildAnswerMapFromContribution = function (items, contribution) {
    if (!contribution) {
        return {};
    }
    return items.reduce(function (accumulator, item) {
        var _a;
        var answer = contribution.answers.find(function (entry) { return entry.consultationItemId === item.id; });
        if (!answer) {
            return accumulator;
        }
        if (item.type === "text") {
            accumulator[item.id] = answer.value || "";
            return accumulator;
        }
        if (item.type === "select_unique") {
            accumulator[item.id] = ((_a = answer.jsonValue) === null || _a === void 0 ? void 0 : _a[0]) || "";
            return accumulator;
        }
        accumulator[item.id] = answer.jsonValue || [];
        return accumulator;
    }, {});
};
export var buildUserSupportsMap = function (contributions, consultationId, comments) {
    var availableCommentIds = new Set(collectCommentIds(comments));
    return contributions.reduce(function (accumulator, entry) {
        if (entry.contribution.consultationId !== consultationId) {
            return accumulator;
        }
        entry.supports.forEach(function (support) {
            if (availableCommentIds.has(support.commentId)) {
                accumulator[support.commentId] = support.id;
            }
        });
        return accumulator;
    }, {});
};
export var matchesConsultationFilters = function (consultation, filters) {
    var _a, _b, _c;
    if (!allowedPublicStatuses.includes(consultation.status)) {
        return false;
    }
    if (filters.agencyId !== "all" &&
        consultation.agencyId !== filters.agencyId) {
        return false;
    }
    if (filters.themeId !== "all" && consultation.themeId !== filters.themeId) {
        return false;
    }
    if (filters.status !== "all" && consultation.status !== filters.status) {
        return false;
    }
    var normalizedSearch = filters.search.trim().toLowerCase();
    if (!normalizedSearch) {
        return true;
    }
    var fields = [
        consultation.title,
        consultation.description,
        (_a = consultation.agency) === null || _a === void 0 ? void 0 : _a.name,
        (_b = consultation.agency) === null || _b === void 0 ? void 0 : _b.acronym,
        (_c = consultation.theme) === null || _c === void 0 ? void 0 : _c.name,
        consultation.municipio,
    ];
    return fields.some(function (field) {
        return (field || "").toLowerCase().includes(normalizedSearch);
    });
};
var collectCommentIds = function (comments) {
    return comments.flatMap(function (comment) { return __spreadArray([
        comment.id
    ], collectCommentIds(comment.childrenComments || []), true); });
};
